import React from 'react'

import RobotHead from "../../images/logo/robot_head/robot2.png"
import MobileSettings from './MobileSettings';

import StandardForm from '../forms/StandardForm';

import useExchangeStore from "../../stores/ExchangesStore"
import useUserStore from "../../stores/UserStore"

import axios from 'axios';
import Cookies from 'js-cookie'

import { FiDelete } from "react-icons/fi";

function MobileMyProfile() {
  const {exchanges_list} = useExchangeStore()
  const logOut = useUserStore((state) => state.logOut)
  const {userID} = useUserStore()
  const token = Cookies.get('token')

  const add_exchanges_list = ["binance", "binance_futures", "bybit_SPOT", "bybit_USDT_PERP", "kucoin", "kucoin_futures"]
  const input_list = ["exchange_name", "api_key", "api_secret"]
  const url = '/api/make_exchange'
  const strat = 'exchange'
  const details = "undefined"

  const kill_exchange = async (exchange_id) => {
    const url = '/api/kill_exchange'
    try {
        await axios({
            headers: { Authorization: token },
            timeout : 2000,
            url : url,
            data : {exchange_id : userID+'@'+exchange_id},
            method: 'POST'
        })
        } catch (err) {
          console.log(err)
        }
}  

  return (
    <div className='mobile_container'>
      <div className="mobile_subcontainer_profile">
        <div className="mobile_profile_container">
          <div className="profile_image_container">
          <img className="profile_image" src={RobotHead}/>
          </div>
          
          <div className="text_container"> 
            <div className='text'>
              <div className="online_container">
              <span className='round'>"</span><h3>Online</h3>
              </div>
              
            <button className="btn profile_logout_btn" onClick={() => logOut()}>Logout</button>
            </div>
          
          </div>
          
        </div>
      </div>

      <div className="mobile_subcontainer_profile">
        <h3 className='mobile_my_exchanges_title'>My exchanges</h3>
      <ul  className="ul_exchange">     
        {Object.keys(exchanges_list).map(function(exchange) {
            return <li className="exchange_state_container" key={exchange}>
              {/* <AiFillDelete onClick={() => kill_exchange(exchange)} className="delete_icon no_drag" /> */}
              <h3 className="exchange_title" > {exchange} </h3>
              <FiDelete onClick={() => kill_exchange(exchange)} className="delete_icon no_drag" />
              </li>
        })}
      </ul>
      <div className="add_exchange_form_container">
        <h3 className="add_exchange_title">Add an exchange</h3>
        <StandardForm input_list={input_list} strat={strat} url={url} button_list={add_exchanges_list} details={details}/>
      </div>
      <h3 className='mobile_my_exchanges_title'>My Settings</h3>
      </div>
      
      <MobileSettings/>
     

      
    </div>
  )
}

export default MobileMyProfile



